import Body from "./components/Body/Body"
import About from "./components/About/About"
import Experience from "./components/Experience/Experience"
import Project from "./components/Project/Project"
import Education from "./components/Education/Education"
import Contact from "./components/Contact/Contact"
import Navbar from "./components/Navbar/Navbar"

function App() {
  return (
    <div className="smooth-scroll">
      <Navbar />
      <main>
        <Body />
        <About />
        <Experience />
        <Project />
        <Education />
        <Contact />
      </main>
    </div>
  )
}

export default App
